// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header_Jucjb","headerContainer":"App_headerContainer_12R5y","logo":"App_logo_1mkhn","nav":"App_nav_3JsIY","navLink":"App_navLink_GnHuZ","footer":"App_footer_2h3bh"};